import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import { CHAT_PROD_ADDON_KEY, CHAT_STAGING_ADDON_KEY } from '../common/constants';
import type { ErrorReason, State } from '../model/types';

export const getBaseUrl = (state: State): BaseUrl => state.baseUrl;
export const getAddonKey = (
	state: State,
): string => // environment may be `unknown` when running in explore mode so we manually check the hostname
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	state.environment === 'staging' || window.location.hostname.includes('jira-dev.com')
		? CHAT_STAGING_ADDON_KEY
		: CHAT_PROD_ADDON_KEY;
export const getIsLoading = (state: State): boolean => state.isLoading;
export const getIsInstalled = (state: State): boolean => state.isInstalled;
export const getIsEnabled = (state: State): boolean => state.isEnabled;
export const getErrorReason = (state: State): ErrorReason => state.errorReason;
export const getErrorMessage = (state: State): string => state.errorMessage;
